import React from "react";
import _ from "lodash";
import { observer } from "mobx-react";
import styled from "styled-components";

import { DropTarget } from "react-dnd";
import { ItemTypes } from "../constants/elements";
import * as Colors from "../reusable/colors";
import { DragSource } from "react-dnd";
import blockStore, { selectBlock, changeBlockParent, block, addBlock } from "../canvas/store";

const LayerItem = styled.div`width: 100%;`;

const LayerBox = styled.div`
  border-left: 1px solid ${Colors.separatorDark};
  border-top: ${p => p.top && "1px solid " + Colors.separatorDark};
  border-bottom: ${p => p.bottom && "1px solid " + Colors.separatorDark};
  padding: 8px 0px 8px 7px;
  cursor: pointer;
  color: ${p => p.selected && Colors.TextHeader};
  background-color: ${p =>
    p.droppable
      ? Colors.highLightSecondary
      : p.selected ? Colors.highLightPrimary : Colors.primary};
  &:hover {
    background-color: ${Colors.highLightPrimary};
  }
`;

const Label = styled.span`border-bottom: ${p => p.selected && "1px solid " + Colors.Text};`;

const Layers = styled.div`
  text-align: left;
  overflow-y: auto;
  height: calc(100% - 300px);
`;

const Children = styled.div`padding-left: 6px;`;

const Layer = observer(p => {
  const { connectDropTarget, isOverCurrent, connectDragSource, canDrop, last } = p;
  return connectDragSource(
    connectDropTarget(
      <div>
        <LayerItem>
          <LayerBox
            droppable={canDrop && isOverCurrent}
            onClick={() => selectBlock(p.id)}
            top={p.idx !== 0}
            bottom={p.children.length > 0 || last}
            selected={blockStore.selected === p.id}>
            <Label>{p.label}</Label>
          </LayerBox>
          <Children>
            {p.children.length > 0 &&
              p.children.map((cid, idx) => (
                <DnDLayer
                  key={cid}
                  {...block(cid)}
                  idx={idx}
                  last={last && idx === p.children.length - 1}
                />
              ))}
          </Children>
        </LayerItem>
      </div>
    )
  );
});

export default observer(() => {
  return (
    <Layers>
      <DnDLayer last={true} {...block("canvas")} />
    </Layers>
  );
});

const boxTarget = {
  drop(props, monitor, block) {
    if (!monitor.didDrop()) {
      if (monitor.getItem().id) {
        changeBlockParent(monitor.getItem().id, props.id);
      } else {
        addBlock(monitor.getItemType(), 20, 20, monitor.getItem(), props.id);
      }
    }
  },
  canDrop(props, monitor) {
    return [ItemTypes.ELEMENT_EMPTYCONTAINER].includes(props.type);
  }
};

const collect = (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true })
  };
};

const boxSource = {
  beginDrag(props, monitor) {
    return { id: props.id };
  },
  endDrag(props, monitor) {}
};

const collectSource = (connect, monitor) => {
  return { connectDragSource: connect.dragSource(), isDragging: monitor.isDragging() };
};

const DnDLayer = _.flow(
  DragSource(p => p.type, boxSource, collectSource),
  DropTarget(
    [
      ItemTypes.ELEMENT_TEXT,
      ItemTypes.ELEMENT_IMAGE,
      ItemTypes.ELEMENT_SLIDER,
      ItemTypes.ELEMENT_EMPTYCONTAINER,
      ItemTypes.ELEMENT_PROGRESSBAR,
      ItemTypes.ELEMENT_VIDEO,
      ItemTypes.ELEMENT_ICON
    ],
    boxTarget,
    collect
  )
)(Layer);



// WEBPACK FOOTER //
// ./src/canvas/layers.js